import React, { createContext, useContext, useRef } from "react";
import { Toast, ToastSeverityType } from "primereact/toast";
import {
  toMessageText,
  uppercaseFirstLetter,
} from "../helpers/helperFunctions";

export type ToastShowProps = {
  severity?: ToastSeverityType;
  detail?: React.ReactNode | string;
  life?: number;
};

type ToastsContext = {
  show: (props: ToastShowProps) => void;
  // clearAll: () => void;
};

const Toasts = createContext<ToastsContext>({
  show: () => null,
  // clearAll: () => null,
});

export const ToastProvider = ({
  children,
}: React.HtmlHTMLAttributes<HTMLElement>) => {
  const toast = useRef<any>(null);

  const show = ({
    severity = "success",
    detail,
    life = 4000,
  }: ToastShowProps) => {
    toast.current.show({
      severity,
      summary: severity.toUpperCase(),
      detail: uppercaseFirstLetter(toMessageText(detail)),
      life,
    });
  };
  return (
    <Toasts.Provider value={{ show }}>
      {children}
      <Toast ref={toast} />
    </Toasts.Provider>
  );
};

export const useToast = () => useContext<ToastsContext>(Toasts);
